<template>
	<div>
		<div class="form-title" style="margin-bottom: 10px">Đăng ký</div>
		<div v-if="this.secureTypeID == 1 || this.secureTypeID == 19"
          style="
            color: var(--3B3B3B, #3c3c3c);

            text-align: center;
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 24px; /* 150% */
            margin-bottom: 20px;
          ">
          Nhập mã xác thực gửi về SĐT {{ this.secureDataInfo }} để kích hoạt tài khoản MyVTC
        </div>
		<div @submit.prevent="registerStep2" class="main-form" ref="overlayWrapper">
			<label for="otp">Mã xác thực</label>
			<input v-model="secureCode" type="text" id="otp" placeholder="Nhập mã xác thực" 
			@keyup="checkInput" v-on:keypress="regex($event)" v-on:focus="focusField" @copy.prevent @paste.prevent maxlength="6"/>

			<small class="warning" v-show="showWarning">
				<img src="@/assets/images/warning.png" alt="" />{{ textWarinng }}
			</small>
			<a href="javascript:void(0)" class="btn-forget" @click="() => {$router.push({ name: 'regselectsecure', params: {}})}">Gửi mã cho tôi?</a>
		</div>

		<a href="javascript:void(0)"  class="btn-next cursor-pointer" :class="{ 'blur': disableBtnNext}" v-on="disableBtnNext ? { } : {click: registerStep2}" style="margin-bottom: 40px">Tiếp theo</a>

		<a href="javascript:void(0)" class="btn-back" style="margin-bottom: 100px" @click="() => {$router.push({ name: 'regusername', params: {}})}">
			<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
				<path
					d="M6.72488 10.4525L13.6911 17.09C13.8074 17.2008 13.9618 17.2626 14.1224 17.2626C14.283 17.2626 14.4374 17.2008 14.5536 17.09L14.5611 17.0825C14.6177 17.0287 14.6627 16.9641 14.6935 16.8924C14.7242 16.8207 14.7401 16.7436 14.7401 16.6656C14.7401 16.5876 14.7242 16.5104 14.6935 16.4387C14.6627 16.3671 14.6177 16.3024 14.5611 16.2487L8.00113 9.9987L14.5611 3.7512C14.6177 3.69749 14.6627 3.63283 14.6935 3.56116C14.7242 3.4895 14.7401 3.41232 14.7401 3.33433C14.7401 3.25634 14.7242 3.17916 14.6935 3.10749C14.6627 3.03583 14.6177 2.97117 14.5611 2.91745L14.5536 2.90995C14.4374 2.79915 14.283 2.73733 14.1224 2.73733C13.9618 2.73733 13.8074 2.79915 13.6911 2.90995L6.72488 9.54745C6.66362 9.60582 6.61484 9.67603 6.58152 9.75381C6.54819 9.83159 6.53101 9.91533 6.53101 9.99995C6.53101 10.0846 6.54819 10.1683 6.58152 10.2461C6.61484 10.3239 6.66362 10.3941 6.72488 10.4525Z"
					fill="#0355CE" />
			</svg>
			Quay lại
		</a>
	</div>
</template>
<script>
import { useRegStore } from "@/store";
export default {
	data() {
		const regStore = useRegStore();
		return {
			regStore,
			secureCode: "",
			showWarning: false,
			textWarinng: null,
			secureDataInfo: regStore.secureDataInfo,
			secureTypeID: regStore.secureTypeID,
			disableBtnNext: true,
		};
	},
	methods: {
		registerStep2() {
			const regStore = useRegStore();
			regStore.secureCode = this.secureCode;
			let loader = this.$loading.show({
				// Optional parameters
				container: this.$refs.overlayWrapper,
				canCancel: false,
			});
			regStore.register(2)
				.then((response) => {
					loader.hide();
					if (response.ResponseCode > 0) {
						regStore.requestId = response.Data.RequestID;
						regStore.signNextStep = response.Data.SignNextStep;
						this.showWarning = false;
						this.$router.push({
							name: 'regaccountinfo',
							params: {}
						});
						return;
					}
					this.textWarinng = this.$t(`register.${response.ResponseCode}`, {}, response.Description);
					this.showWarning = true;
					return;
				})
				.catch((error) => {
					loader.hide();
					console.error(error);
					this.textWarinng = "Hệ thống đang bận vui lòng thử lại sau";
					this.showWarning = true;
				});
		},
		checkInput(){
			if (this.secureCode.length == 4 || this.secureCode.length == 6 ) {
				this.disableBtnNext = false;
				this.textWarinng = "";
				this.showWarning = false;
			}
			else{
				this.textWarinng = "Mã xác thực bao gồm 4 hoặc 6 chữ số";
				this.disableBtnNext = true;
				this.showWarning = true;
			}
			
		},
		regex(e){
			let char = String.fromCharCode(e.keyCode); // Get the character
			let checkSo = /^[0-9]+$/.test(char);
			if(checkSo) return true;
			e.preventDefault();
		},
		focusField(){
			this.textWarinng = "Nếu không nhận được mã xác thực, soạn tin MYVTC gửi 8030 từ số điện thoại đăng ký (Chỉ hỗ trợ Viettel, Mobifone, Vinaphone)";
			this.showWarning = true;
		}
	},
};
</script>
<style lang="">
</style>